function prescriptionWA(payload) {
    var WA = `
        Hola ${payload.patient_first_name},
        \nTu prescripción médica la podrás ver en el PDF. 
        \nTu opinión es importante para nosotros. ¿Puedes ayudarnos a responder la siguiente encuesta satisfacción?
        \n
    `
    return WA
}

export { prescriptionWA }